import React from "react";
import ScrollToTop from "../components/scroll-to-top";
import SEO from "../components/seo";
import ContactForms from "../containers/Contactus/index.jsx";
import CallToAction from "../containers/global/call-to-action/index.jsx";
import Whychooseus from "../containers/home/whychoseus/index.jsx";
import Footer from "../layouts/footer";
import Header from "../layouts/header";
import Layout from "../layouts/index.jsx";
const ContactPage = () => {
    return (
        <React.Fragment>
            <Layout>
                <SEO title="Second Opinion – Contact Us" />
                <div className="wrapper">
                    <Header />
                    <div className="main-content site-wrapper-reveal">
                        {/* <PageTitleContainer
                            image="img/photos/contact-bg1.jpg"
                            subTitle="We are always ready to help you"
                            title="Contact Us"
                        /> */}
                        {/* <GoogleMapContainer classOption="contact-map-area" /> */}
                        <div className="tw-flex tw-flex-col md:tw-flex-row">
                            <Whychooseus page='contact' />
                            <ContactForms />
                        </div>
                        <CallToAction />
                    </div>
                    <Footer />
                    <ScrollToTop />
                </div>
            </Layout>
        </React.Fragment>
    );
};

export default ContactPage;
